// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2SE7z","clinicsSelect":"styles_clinicsSelect__2Xw55"};